"use strict";
var ul = document.querySelector("ul");
var parse = function(s) {
    return Number(s.replace(/[^\d.-]/g, ""));
};
sortList(ul);
getEmployees(ul);
function sortList(list) {
    var items = Array.from(list.querySelectorAll("li"));
    items.sort(function(a, b) {
        return parse(b.dataset.salary) - parse(a.dataset.salary);
    });
    items.forEach(function(item) {
        return list.appendChild(item);
    });
}
function getEmployees(list) {
    return Array.from(list.querySelectorAll("li")).map(function(i) {
        return {
            name: i.textContent.trim(),
            position: i.dataset.position,
            salary: parse(i.dataset.salary),
            age: Number(i.dataset.age)
        };
    });
}

//# sourceMappingURL=index.f90f4ff6.js.map
